import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";

import { MapNavigation } from "./mapNavigation";
import { MapDisplay } from "./mapDisplay";

export function MapWrapper({
  destinations,
  inactiveDestinations = null,
  routeCategory = null,
}) {
  const [currentMapViewIndex, setCurrentMapViewIndex] = useState(0);

  const mapData = useMemo(
    () =>
      destinations
        .filter(dest => dest.meta.coords)
        .map(dest => ({
          lat: dest.meta.coords.lat,
          lng: dest.meta.coords.lon,
          name: dest.name,
          category: dest.meta.category,
        })),
    [destinations]
  );

  const inactiveMapData = useMemo(() => {
    if (!inactiveDestinations || inactiveDestinations.length === 0) {
      return [];
    }
    return inactiveDestinations
      .filter(dest => dest.meta.coords)
      .map(dest => ({
        lat: dest.meta.coords.lat,
        lng: dest.meta.coords.lon,
        name: dest.name,
        category: dest.meta.category,
      }));
  }, [inactiveDestinations]);

  return (
    <section className="relative flex flex-col bg-sand-200 h-screen-dvh">
      <MapNavigation
        routeCategory={routeCategory}
        currentMapViewIndex={currentMapViewIndex}
        setCurrentMapViewIndex={setCurrentMapViewIndex}
      />

      <MapDisplay mapData={mapData} inactiveMarkers={inactiveMapData} />
    </section>
  );
}

MapWrapper.propTypes = {
  destinations: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      meta: PropTypes.shape({
        coords: PropTypes.shape({
          lat: PropTypes.number.isRequired,
          lon: PropTypes.number.isRequired,
        }),
        category: PropTypes.string.isRequired,
      }),
    })
  ).isRequired,
  inactiveDestinations: PropTypes.arrayOf(
    PropTypes.shape({
      meta: PropTypes.shape({
        coords: PropTypes.shape({
          lat: PropTypes.number.isRequired,
          lon: PropTypes.number.isRequired,
        }),
        category: PropTypes.string.isRequired,
      }),
    })
  ),
  routeCategory: PropTypes.string,
};
